export const columns = [
  { accessorKey: "vehicleNumber", header: "Vehicle", flex: 1 },

  {
    accessorKey: "secondaryScanDecision",
    header: "Secondary Inspection",
    flex: 1.2,
    accessorFn: (row: any) => ` ${row.secondaryScanDecision || " "}`,
  },
  { accessorKey: "departmentName", header: "Assigned Department", flex: 1.6 },
  {
    accessorKey: "comments",
    header: "Remarks",
    flex: 1.5,
    accessorFn: (row: any) => ` ${row.comments || " "}`,
  },
  {
    accessorKey: "actionButtons",
    header: "Actions",
    flex: 0.8,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
];
